import text from './text.json'
import {InfoIcon} from '../../icons'
import {colors} from '../../utils/colors'
import {useSelector} from 'react-redux'
import classNames from 'classnames'

const InfoBox = ({value, type}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const channelInfoTexts = {
        email: text.code_description_email.replace(':value', value || text.entered),
        sms: text.code_description_sms.replace(':value', value || text.entered)
    }

    return (
        <div className={classNames('form-info-box', {
            dark: isDarkMode
        })}>
            <span className="info-icon">
                <InfoIcon color={colors.colorBlue}/>
            </span>
            <div className="info-box-text">
                <span
                    dangerouslySetInnerHTML={{__html: channelInfoTexts[type]}}/>
            </div>
        </div>
    )
}

export default InfoBox
